var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareDevelopment17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1362 -14427) translate(326 13726) translate(896 661) translate(140 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.2,
    cy: 46.2,
    r: 46.2,
    fill: "#F6FBFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2691E9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.22 10.717c-.043-.458-.428-.808-.889-.808h-4.517c-.492 0-.892.4-.892.892 0 .493.4.893.892.893h3.706l2.3 24.22H2.031l2.3-24.22h3.313c.492 0 .892-.4.892-.893 0-.492-.4-.892-.892-.892H3.519c-.46 0-.844.35-.888.808L.162 36.72c-.023.25.06.5.229.685.168.186.408.292.66.292H35.8c.25 0 .49-.107.66-.292.168-.185.251-.434.227-.685L34.22 10.717z",
    transform: "translate(27 27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.92 9.909c-.493 0-.893.4-.893.892 0 .493.4.892.892.892h6.619c.493 0 .892-.4.892-.892 0-.493-.4-.892-.892-.892h-6.619z",
    transform: "translate(27 27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.281 17.13c1.173 0 2.128-.955 2.128-2.128 0-.853-.508-1.586-1.236-1.924V8.065c0-3.34 2.717-6.056 6.056-6.056 3.338 0 6.054 2.717 6.054 6.056v5.013c-.726.34-1.234 1.071-1.234 1.924 0 1.173.954 2.127 2.126 2.127 1.174 0 2.129-.954 2.129-2.127 0-.853-.509-1.586-1.237-1.925V8.065c0-4.323-3.516-7.84-7.838-7.84-4.323 0-7.84 3.517-7.84 7.84v5.013c-.727.34-1.235 1.071-1.235 1.924 0 1.173.955 2.127 2.127 2.127z",
    transform: "translate(27 27)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment17);
export default __webpack_public_path__ + "static/media/software-development17.26e354bc244f45c9f94ff6356cc09a54.svg";
export { ForwardRef as ReactComponent };